export const netSuiteApiPaths = <const>{
    customers: ':companyId/netsuite/:documentType/customers',
    customer: ':companyId/netsuite/:documentType/customers/:customerId',
    discountItems: ':companyId/netsuite/discount-items',
    opportunities: ':companyId/netsuite/:documentType/opportunities',
    partners: ':companyId/netsuite/:documentType/partners',
    leadSources: ':companyId/netsuite/:documentType/lead-sources',
    shippingMethods: ':companyId/netsuite/:documentType/shipping-methods',
    employees: ':companyId/netsuite/:documentType/employees',
    priceLevels: ':companyId/netsuite/:documentType/price-levels',
    projectTasks: ':companyId/netsuite/customers/:customerId/project-tasks',
    amortizationSchedules: ':companyId/netsuite/:documentType/:sublistType/amortization-schedules',
    taxAccounts: ':companyId/netsuite/:documentType/tax-accounts',
    billMatching: 'companies/:companyId/netsuite/vendor-bills/:vendorBillRequestId/matching/requests',
    poMatching: 'companies/:companyId/netsuite/purchase-orders/:purchaseOrdersRequestId/matching/requests',
};
